export default class MapFullscreeenEnum {
    static MAP_FULLSCREEN_TRIGGER = '[data-trigger="map-fullscreen"]'
}
